/**
 * @desc 根据id查询
 */
import { PriceIndexEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPriceIndexParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/priceIndex'

export const queryPriceIndexApi = (
  params?: QueryPriceIndexParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PriceIndexEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryPriceIndexApi.method = method
queryPriceIndexApi.url = url
